<template>
  <div class="rf-acciones d-print-none">
    <div class="rf-acciones-botones">
      <v-btn outlined color="primary" :disabled="!documento || preparando || generando"
        :loading="preparando" @click="imprimir">
        <v-icon left>print</v-icon>Imprimir
      </v-btn>
      <v-btn color="primary" depressed :disabled="!documento || preparando || generando"
        :loading="generando" @click="descargarPdf">
        <v-icon left>file_download</v-icon>Descargar PDF
      </v-btn>
    </div>
    <p v-if="error" class="rf-acciones-error" role="alert">{{ error }}</p>
  </div>
</template>

<script>
import fileDownload from 'js-file-download';

import { generarPdfReporte, nombreArchivoReporte } from './exportarPdf';

export default {
  name: 'AccionesReporteFisico',
  props: {
    documento: { type: String, default: '' },
    reporte: { type: Object, required: true },
    contrato: { type: Object, default: null },
    vistaImpresion: { type: Boolean, default: false },
  },
  data: () => ({ generando: false, preparando: false, error: '' }),
  methods: {
    async esperarImagenes() {
      await this.$nextTick();
      if (document.fonts && document.fonts.ready) await document.fonts.ready;
      const imagenes = Array.from(document.querySelectorAll('.rf-documento img'));
      await Promise.all(imagenes.map((imagen) => new Promise((resolve, reject) => {
        const mensaje = 'No se cargaron todas las imágenes del reporte. Reabre el reporte y vuelve a intentarlo.';
        if (imagen.complete) {
          if (imagen.naturalWidth) resolve();
          else reject(new Error(mensaje));
          return;
        }
        let temporizador;
        const terminar = (fallo) => {
          clearTimeout(temporizador);
          // Los callbacks ya están definidos cuando se ejecuta terminar.
          // eslint-disable-next-line no-use-before-define
          imagen.removeEventListener('load', cargada);
          // eslint-disable-next-line no-use-before-define
          imagen.removeEventListener('error', fallida);
          if (fallo) reject(new Error(mensaje));
          else resolve();
        };
        const cargada = () => terminar(false);
        const fallida = () => terminar(true);
        imagen.addEventListener('load', cargada);
        imagen.addEventListener('error', fallida);
        temporizador = setTimeout(fallida, 20000);
      })));
    },
    async imprimir() {
      this.error = '';
      if (!this.vistaImpresion) {
        const { href } = this.$router.resolve({
          name: 'imprimirReporteFisico',
          params: { idContrato: this.reporte.idContrato, idReporte: this.reporte.id },
          query: { imprimir: '1' },
        });
        // Abrir durante el clic evita el bloqueo de ventanas emergentes.
        const ventana = window.open(href, '_blank');
        if (ventana) ventana.opener = null;
        else this.error = 'El navegador bloqueó la ventana. Permite ventanas emergentes para imprimir.';
        return;
      }
      this.preparando = true;
      try {
        await this.esperarImagenes();
        window.print();
      } catch (error) {
        this.error = error.message;
      } finally {
        this.preparando = false;
      }
    },
    async descargarPdf() {
      this.error = '';
      this.generando = true;
      try {
        await this.esperarImagenes();
        const pdf = await generarPdfReporte(this.axios, this.documento);
        fileDownload(pdf, `${nombreArchivoReporte(this.contrato, this.reporte)}.pdf`);
      } catch (error) {
        this.error = 'No se pudo generar el PDF. Verifica la conexión con el generador y vuelve a intentarlo.';
        if (!error.response && /imágenes/.test(error.message)) this.error = error.message;
      } finally {
        this.generando = false;
      }
    },
  },
};
</script>

<style scoped>
.rf-acciones-botones { display: flex; justify-content: flex-end; gap: 12px; flex-wrap: wrap; }
.rf-acciones-error { margin: 12px 0 0; color: var(--v-primary-base); font-size: 14px; }
</style>
